import { render, staticRenderFns } from "./CardInstrumentoProtesto.vue?vue&type=template&id=6e3088b1&scoped=true"
import script from "./CardInstrumentoProtesto.vue?vue&type=script&lang=js"
export * from "./CardInstrumentoProtesto.vue?vue&type=script&lang=js"
import style0 from "./CardInstrumentoProtesto.vue?vue&type=style&index=0&id=6e3088b1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e3088b1",
  null
  
)

export default component.exports